import React, { createContext } from 'react';
import * as compose from 'lodash.flowright';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'next/router';
import Loading from '../components/Loading';
import { __ } from '../lib/I18n';
import { getCookie } from '../lib/Util';

const AuthContext = createContext({});

const routeAccess = {
  '/plan/[id]/editPlan': {
    type: 'EDIT',
  },
  '/plan/newPlan': {
    type: 'EDIT',
  },
  '/product/[id]/editProduct': {
    type: 'EDIT',
  },
  '/product/newProduct': {
    type: 'EDIT',
  },
  '/entity/addContract': {
    type: 'EDIT',
  },
  '/settings/permissions': {
    type: 'ADMIN',
  },
  '/settings/bank': {
    scope: 'READ_ACCOUNT'
  }
};

class AuthProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validating: true,
    };
  }

  async componentDidMount() {
    const { store, router } = this.props;
    const splittedRoute = router.route.split('/');
    const baseRoute = splittedRoute.length > 1 ? splittedRoute[1] : splittedRoute[0];

    // Check if user is logged in
    if (!store?.user?.organizations?.length) {
      if (baseRoute !== 'serviceContract') {
        const accessToken = getCookie(null, 'accessToken');
        const cookieSelectedOrganization = getCookie(null, 'selectedOrganizationId');

        if (accessToken || cookieSelectedOrganization) await store.logout(null);
        if (router.route !== '/login') await router.replace('/');
      }
    } else {
      const { selectedOrganizationId, organizations } = store.user;
      const { accessType, entityScopes, recipientTags, accounts, taxId } = organizations.find(
        organization => organization.id === selectedOrganizationId
      ) || {};

      if (baseRoute === 'serviceContract' && recipientTags.totalCount && accounts.totalCount && taxId) {
        await router.replace('/');
      } else if (!this.canAccess(accessType, entityScopes, router.route)) {
        // If user doesn't have permission to access this page, redirect them to error page
        store.setErrorMessage({
          title: __('Erro de acesso'),
          message: __('Você não tem permissão para acessar essa página.')
        });

        await router.push('/error');
      } else if (router.route.includes('/login')) { // If user is in login page, redirect to initial page
        await router.push('/');
      }
    }
    this.setState({ validating: false });
  }

  canAccess = (accessType, scopes, route) => {
    if (accessType !== 'ADMIN' && routeAccess[route]) {
      if (routeAccess[route].scope && !scopes.includes(routeAccess[route].scope)) return false;
      return routeAccess[route].type === accessType;
    }

    return true;
  };

  render() {
    const { children } = this.props;
    const { validating } = this.state;

    if (validating) return <Loading height={80} width={80} />;

    return <AuthContext.Provider value={{}}>{children}</AuthContext.Provider>;
  }
}

export default compose(
  withRouter,
  inject('store'),
  observer
)(AuthProvider);
